import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../../colorVars';
import { addExitTactic } from '../../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addExitTactic';
import { useWebsocketStore } from '../../../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../../../atomic/buttons/textButton/TextButton';
import CheckBox from '../../../../../../../../../atomic/formElements/checkBox/CheckBox';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { TableSelect } from '../../../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import { candleTrailValidation } from '../../../../../../../../../forms/tradeplans/AddTradePlan/DataValidation';
import { IndividualPanelHeader } from '../../../../individualTacticPanels/IndividualPanelHeader';
import style from './IndividualAddTacticPanel.module.css';

export const AddCandleTrailTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const [headerText, setHeaderText] = useState('Add Candle Trail');
    const [headerTextColor, setHeaderTextColor] = useState(colors.lightGrey);
    const [details, setDetails] = useState({
      candleDuration: 1,
      timeUnit: 'MINUTES',
      breakBy: 0,
      usePrePostMarketData: false,
    });
    const timeoutRef = useRef(null);

    const addTactic = () => {
      const validationResult = candleTrailValidation(details);
      if (validationResult[0] === false) {
        setHeaderText(validationResult[1]);
        setHeaderTextColor(colors.red);
        const timer = setTimeout(() => {
          setHeaderText('Add Candle Trail');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      } else {
        addExitTactic(tradePlanId, {
          tactic: 'CANDLE_TRAIL',
          details,
        });
        setHeaderText('Candle Trail Added');
        setHeaderTextColor(colors.green);
        const timer = setTimeout(() => {
          setHeaderText('Add Candle Trail');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      }
    };
    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, []);
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableFieldNoOnBlurUpdate
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                    fontSize={fontSizes.body3}
                    value={details.candleDuration}
                    setValue={(newValue) =>
                      setDetails((prev) => ({
                        ...prev,
                        candleDuration: newValue,
                      }))
                    }
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Time Unit
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <TableSelect
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                    value={details.timeUnit}
                    options={[
                      { label: 'Minute', value: 'MINUTES' },
                      { label: 'Day', value: 'DAYS' },
                      { label: 'Week', value: 'WEEKS' },
                      { label: 'Month', value: 'MONTHS' },
                      { label: 'Quarter', value: 'QUARTERS' },
                      { label: 'Year', value: 'YEARS' },
                    ]}
                    onChange={(value) =>
                      setDetails((prev) => ({ ...prev, timeUnit: value }))
                    }
                  />
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Break By
                  </Body3>
                </td>
                <td className={style.labelTd}>
                  <div className={style.inputWrapper}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.breakBy}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          breakBy: newValue,
                        }))
                      }
                    />
                  </div>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Use Pre/Post Data
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <CheckBox
                      margin="5px 0 0 0"
                      fontSize={fontSizes.body4}
                      checked={details.usePrePostMarketData}
                      onChange={(checked) =>
                        setDetails((prev) => ({
                          ...prev,
                          usePrePostMarketData: checked,
                        }))
                      }
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <header className={style.header}>
            <Body3 color={headerTextColor} fontWeight={700}>
              {headerText}
            </Body3>
            <TextButton
              disabled={tradePlan.exitTactics['CANDLE_TRAIL']}
              color={colors.lightGrey}
              backgroundColor={
                tradePlan.exitTactics['CANDLE_TRAIL']
                  ? colors.grey
                  : colors.blue
              }
              fontSize="small"
              clickHandler={addTactic}
              width="20%"
              height="50%"
            >
              Add
            </TextButton>
          </header>
        </div>
      </TabPanel>
    );
  }
);

AddCandleTrailTacticPanel.tabsRole = 'TabPanel';
